/**
 * Scrubber 2029: API helpers. Same origin under /api/scrubber-2029 on Core's
 * session cookie.
 */
const API_ROOT = process.env.REACT_APP_API_URL || '';
export const API = `${API_ROOT}/api/scrubber-2029`;

export async function getJson(path, opts = {}) {
  const r = await fetch(`${API}${path}`, { credentials: 'include', ...opts });
  let data = null;
  try { data = await r.json(); } catch (_) { data = null; }
  if (!r.ok) {
    const msg = (data && (data.error || data.message)) || `Request failed (${r.status})`;
    const err = new Error(msg); err.status = r.status; err.data = data; throw err;
  }
  return data;
}
export function postForm(path, formData) { return getJson(path, { method: 'POST', body: formData }); }

export async function downloadBlob(path, { method = 'GET', json, filename }) {
  const opts = { credentials: 'include', method };
  if (json) { opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(json); }
  const r = await fetch(`${API}${path}`, opts);
  if (!r.ok) {
    let msg = `Download failed (${r.status})`;
    try { const d = await r.json(); msg = d.error || d.message || msg; } catch (_) { /* keep */ }
    throw new Error(msg);
  }
  const blob = await r.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename || 'download';
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
}

export const PROTOCOLS = [
  { key: 'ODAG', label: 'ODAG', title: 'Part C Organization Determinations, Appeals, and Grievances', part: 'Part C', available: true },
  { key: 'CDAG', label: 'CDAG', title: 'Part D Coverage Determinations, Appeals, and Grievances', part: 'Part D', available: false },
  { key: 'FA', label: 'FA', title: 'Part D Formulary and Benefit Administration', part: 'Part D', available: false },
  { key: 'SNPCC', label: 'SNPCC', title: 'Special Needs Plans Care Coordination', part: 'SNP', available: false },
  { key: 'CPE', label: 'CPE', title: 'Compliance Program Effectiveness', part: 'Parts C and D', available: false },
];

// Every table of the CMS-10717 package (2027 audit year and later), so the user sees the whole plan; only the
// ones the server lists are enabled.
export const TABLE_PLAN = {
  ODAG: [
    { key: 'odag_2029_table1_od', number: 1, abbrev: 'OD', name: 'Standard and Expedited Coverage Organization Determinations' },
    { key: 'odag_2029_table2_recon', number: 2, abbrev: 'RECON', name: 'Standard and Expedited Coverage Reconsiderations' },
    { key: 'odag_2029_table3_pymt_c', number: 3, abbrev: 'PYMT_C', name: 'Payment Organization Determinations and Reconsiderations' },
    { key: 'odag_2029_table4_grv_c', number: 4, abbrev: 'GRV_C', name: 'Part C Standard and Expedited Grievances' },
    { key: 'odag_2029_table5_rcd', number: 5, abbrev: 'RCD', name: 'Reopened Part C Determinations' },
  ],
  CDAG: [
    { key: 'cdag_2029_table1_cd', number: 1, abbrev: 'CD', name: 'Standard and Expedited Coverage Determinations' },
    { key: 'cdag_2029_table2_cder', number: 2, abbrev: 'CDER', name: 'Coverage Determination Exception Requests' },
    { key: 'cdag_2029_table3_pymt_d', number: 3, abbrev: 'PYMT_D', name: 'Payment Coverage Determinations and Redeterminations' },
    { key: 'cdag_2029_table4_rd', number: 4, abbrev: 'RD', name: 'Standard and Expedited Redeterminations' },
    { key: 'cdag_2029_table5_eff_d', number: 5, abbrev: 'EFF_D', name: 'Effectuations of Overturned Decisions by IRE, ALJ or MAC' },
    { key: 'cdag_2029_table6_grv_d', number: 6, abbrev: 'GRV_D', name: 'Part D Standard and Expedited Grievances' },
  ],
  FA: [
    { key: 'fa_2029_table1_rcfa', number: 1, abbrev: 'RCFA', name: 'Rejected Claims Formulary Administration' },
    { key: 'fa_2029_table2_rct', number: 2, abbrev: 'RCT', name: 'Rejected Claims Transition' },
    { key: 'fa_2029_table3_ne', number: 3, abbrev: 'NE', name: 'New Enrollee' },
  ],
  SNPCC: [
    { key: 'snpcc_2029_table1_snpne', number: 1, abbrev: 'SNPNE', name: 'Special Needs Plans New Enrollees' },
    { key: 'snpcc_2029_table2_snpce', number: 2, abbrev: 'SNPCE', name: 'Special Needs Plans Continuing Enrollees' },
  ],
  CPE: [
    { key: 'cpe_2029_table1_coa', number: 1, abbrev: 'COA', name: 'Compliance Oversight Activities' },
  ],
};

export const fmtNum = (n) => (n === null || n === undefined || n === '' ? '' : Number(n).toLocaleString());
export const todayIso = () => new Date().toISOString().slice(0, 10);
